import React, { useEffect, useState } from 'react'
import './buynow.css';
import allStates from './Statedata';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate} from 'react-router-dom';
import { BASE_URL } from '../helper'

export default function AddresForm({selectedAddressId}) {


    const navigate = useNavigate()
    const [editbtn, seteditbtn] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        fname: '',
        mobile: '',
        pincode: '',
        address: '',
        area: '',
        landmark: '',
        city: '',
        state: ''
    });


    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let userEmail = localStorage.getItem("userEmail");
        const response = await fetch(`${BASE_URL}/api/orderaddress`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: userEmail,
                fname: formData.fname,
                mobile: formData.mobile,
                pincode: formData.pincode,
                address: formData.address,
                area: formData.area,
                city: formData.city,
                state: formData.state
            })
        });
        const json = await response.json()
        console.log(json);

        if (json.success) {
            toast.success("Address Add Successfully 😃!", {
                position: "top-center",
                autoClose: 2000,
                onClose: () => {
                    window.location.reload()
                    navigate("/checkout");
                }
            });
        } else {
            toast.error("Please check address data 👎!", {
                position: "top-center",
                autoClose: 2000,
            });
        }
    };

    const UpdateSubmit = async (event) => {
        event.preventDefault();
        try {
          const response = await fetch(`${BASE_URL}/api/updateaddress/${selectedAddressId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              fname: formData.fname,
              mobile: formData.mobile,
              pincode: formData.pincode,
              address: formData.address,
              area: formData.area,
              city: formData.city,
              state: formData.state,
            }),
          });
      
          if (response.ok) {
            const json = await response.json();
            toast.success('Update Successfully 😃!', {
              position: 'top-center',
              autoClose: 2000,
              onClose: () => {
                window.location.reload();
                navigate('/checkout');
              },
            });
            console.log(json);
          } 
        } catch (error) {
          console.log(error);
        }
      };
      

      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await fetch(`${BASE_URL}/api/getaddress/${selectedAddressId}`);
            if (response.ok) {
              const jsonData = await response.json();
              setFormData(jsonData);
              seteditbtn(true);
            } else {
              throw new Error('Failed to fetch data');
            }
          } catch (error) {
            console.log(error);
            setError('Failed to fetch data: ' + error.message);
          }
        };
      
        fetchData(); // Call the fetchData function
        // For example, if `dataId` changes, refetch the data
      }, [selectedAddressId]);
    


    return (
        <>
            <div>
                <div className='container'>
                    <div className="left_buy">
                        <div className="heading-top">
                            <h1>Checkout</h1>
                            <p>Add Your Delivery Address</p>
                        </div>
                        <div>
                            <form>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="name">
                                        Full Name:
                                    </label>
                                    <input
                                        type="text"
                                        name="fname"
                                        value={formData.fname}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="mobile">
                                        Mobile Number:
                                    </label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="pincode">
                                        Pincode (6 digits):
                                    </label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        value={formData.pincode}
                                        onChange={handleInputChange}
                                        pattern="[0-9]{6}"
                                        required
                                    />
                                </div>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="address">
                                        Address:
                                    </label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="area">
                                        Area, Street, Sector, Village:
                                    </label>
                                    <input
                                        type="text"
                                        name="area"
                                        value={formData.area}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-label-input">
                                    <label className="chechout-label" htmlFor="landmark">
                                        Landmark:
                                    </label>
                                    <input
                                        type="text"
                                        name="landmark"
                                        value={formData.landmark}
                                        onChange={handleInputChange}
                                        placeholder='e.g near apllo hospital'
                                    />
                                </div>
                                <div className="form-label-input d-flex">
                                    <div className="town_city">
                                        <label className="chechout-label" htmlFor="city">
                                            Town/City:
                                        </label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="form_select">
                                        <label className="chechout-label" htmlFor="state">
                                            Choose a State:
                                        </label>
                                        <select
                                            name="state"
                                            value={formData.state}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">-- Select State --</option>
                                            {allStates.map((state) => (
                                                <option key={state} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {editbtn ? (
                                    <button className="place_oder_btn" onClick={UpdateSubmit}>
                                        Update this address
                                    </button>
                                ) : (
                                    <button className="place_oder_btn" onClick={handleSubmit}>
                                        Add this address
                                    </button>
                                )}
                            </form>
                        </div>
                        <ToastContainer />
                    </div>
                </div>
            </div>
        </>
    )
}
